import { useState } from 'react';
import Hero from './components/Hero';
import TrustStrip from './components/TrustStrip';
import About from './components/About';
import Industries from './components/Industries';
import Services from './components/Services';
import CTA from './components/CTA';

export default function HomePage() {
  return (
    <>
      <div className="min-h-screen bg-white">
        <Hero />
        <TrustStrip />
        <About />
        <Industries />
        <Services />
        <CTA />
      </div>
      <footer className="bg-midnight-navy text-white py-12">
        <div className="max-w-7xl mx-auto px-6 text-center">
          <div className="text-2xl font-serif font-bold mb-2">
            WealthWise<span className="text-wealth-gold">Consulting</span>
          </div>
          <p className="text-soft-silver mb-4">Intelligent Growth. Measurable Results.</p>
          <p className="text-sm text-slate-gray">
            © {new Date().getFullYear()} WealthWiseConsulting. All rights reserved.
          </p>
        </div>
      </footer>
    </>
  );
}
